import { ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RESUMO_FINANCEIRO } from '../types';

export default function alterarRegistrosPorPaginaResumoFinanceiro(valor) {
  return {
    type: ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RESUMO_FINANCEIRO,
    payload: valor
  };
}
